import React, { PropsWithChildren } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { Card, Popover } from 'antd';

import style from './index.less';

export type TitleWithPreviewProps = PropsWithChildren<{
  src?: string;
  type?: 'large' | 'medium' | 'small';
  wideImg?: boolean;
}>;

export default function TitleWithPreview(props: TitleWithPreviewProps) {
  const { src, type = 'large', children, wideImg = false } = props;

  const className = wideImg ? style['preview-wide'] : style.preview;

  return (
    <div className={style.container}>
      <span></span>
      <h1 className={style[type]}>{children}</h1>
      {src ? (
        <div className={style.eye}>
          <Popover
            content={
              <Card bordered={false} className={style.card}>
                <img src={src} className={className} />
              </Card>
            }
            placement='bottom'
          >
            <EyeOutlined />
          </Popover>
        </div>
      ) : null}
    </div>
  );
}
